export const GET_ORDER_BREAD = 'GET_ORDER_BREAD';
export const SUCCESS_GET_ORDER_BREAD = 'SUCCESS_GET_ORDER_BREAD';
export const FAIL_GET_ORDER_BREAD = 'FAIL_GET_ORDER_BREAD';

export const GET_ORDER_BREADS = 'GET_ORDER_BREADS';
export const SUCCESS_GET_ORDER_BREADS = 'SUCCESS_GET_ORDER_BREADS';
export const FAIL_GET_ORDER_BREADS = 'FAIL_GET_ORDER_BREADS';

export const GET_NOTIFICATION_ORDER_BREADS = 'GET_NOTIFICATION_ORDER_BREADS';
export const SUCCESS_GET_NOTIFICATION_ORDER_BREADS = 'SUCCESS_GET_NOTIFICATION_ORDER_BREADS';
export const FAIL_GET_NOTIFICATION_ORDER_BREADS = 'FAIL_GET_NOTIFICATION_ORDER_BREADS';

export const GET_DAY_ORDER_BREADS = 'GET_DAY_ORDER_BREADS';
export const SUCCESS_GET_DAY_ORDER_BREADS = 'SUCCESS_GET_DAY_ORDER_BREADS';
export const FAIL_GET_DAY_ORDER_BREADS = 'FAIL_GET_DAY_ORDER_BREADS';

export const VALIDATE_ORDER_BREAD = 'VALIDATE_ORDER_BREAD';
export const SUCCESS_VALIDATE_ORDER_BREAD = 'SUCCESS_VALIDATE_ORDER_BREAD';
export const FAIL_VALIDATE_ORDER_BREAD = 'FAIL_VALIDATE_ORDER_BREAD';

export const CREATE_ORDER_BREAD = 'CREATE_ORDER_BREAD';
export const SUCCESS_CREATE_ORDER_BREAD = 'SUCCESS_CREATE_ORDER_BREAD';
export const FAIL_CREATE_ORDER_BREAD = 'FAIL_CREATE_ORDER_BREAD';

export const DELETE_ORDER_BREAD = 'DELETE_ORDER_BREAD';
export const SUCCESS_DELETE_ORDER_BREAD = 'SUCCESS_DELETE_ORDER_BREAD';
export const FAIL_DELETE_ORDER_BREAD = 'FAIL_DELETE_ORDER_BREAD';

export const INIT_ORDER_BREAD = 'INIT_ORDER_BREAD';
